import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tabbar_icon_mine_def",
  "use": "icon-tabbar_icon_mine_def-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-tabbar_icon_mine_def\"><path d=\"M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Zm3.333 10.026a.75.75 0 0 1 .55.818l-.02.1-.032.12a4.002 4.002 0 0 1-7.662 0l-.033-.12-.02-.1a.75.75 0 0 1 1.47-.282 2.501 2.501 0 0 0 4.827 0l.002-.006a.75.75 0 0 1 .918-.53Z\" fill=\"#3D3E40\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol